<template>
    <div class="animated fadeIn">
        <CForm
                ref="form"
                v-if="dataFormStructures.order.rows !== undefined"
                :structure="dataFormStructures.order">
            <template v-for="row, rowIndex in dataFormStructures.order.rows">
                <template v-for="col, colIndex in row.cols">
                    <template :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                        <slot v-for="card in col.cards" v-if="card.key !== ''" :slot="card.key">
                            <slot :name="card.key"></slot>
                        </slot>
                    </template>
                </template>
            </template>
        </CForm>
    </div>
</template>

<script>
    var _self = null
    import CForm from '../components/CForm'
    export default {
        name: 'FormOrder',
        components: {
            CForm
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                dataId: '',
                dataFieldRefs: [],
                dataFormStructures: {
                    order: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'productStandardSummary'
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'notes',
                                type: 'notes'
                            },
                            {
                                id: 'productStandardSummary',
                                type: 'productStandardSummary',
                                value: [],
                                updateTotal: function(subTotal, total, form, fieldRefs) {
                                    _self.dataFieldRefs = fieldRefs
                                    _self.$emit('onUpdateTotal', subTotal, total,  form, fieldRefs)
                                }
                            }
                        ]
                    }
                }
            }
        },
        methods: {
        }
    }
</script>
